if (!customElements.get('pdp-results-back')) {
  customElements.define('pdp-results-back', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('.pdp-back-link');
      if (!this.link) return;
      // Mega-menu product images carry an explicit collection return target.
      // Accept only collection paths on this storefront; never redirect off-site.
      try {
        const target = new URL(window.location.href).searchParams.get('he_mega_collection');
        if (target && target.startsWith('/') && !target.startsWith('//')) {
          const collection = new URL(target, window.location.origin);
          if (collection.origin === window.location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^/]+\/?$/i.test(collection.pathname) && !collection.search && !collection.hash) {
            this.link.href = collection.href;
            return;
          }
        }
      } catch { /* Keep ordinary history-based navigation. */ }
      if (document.referrer) {
        try {
          const previous = new URL(document.referrer);
          if (previous.protocol === 'https:' || previous.protocol === 'http:') {
            if (!window.Shopify?.designMode || previous.origin === window.location.origin) this.link.href = previous.href;
          }
        } catch { /* Keep the existing fallback link. */ }
      }
      this.onBackClick = (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (window.Shopify?.designMode || window.history.length < 2) return;
        event.preventDefault();
        window.history.back();
      };
      this.link.addEventListener('click', this.onBackClick);
    }
    disconnectedCallback() {
      if (this.link && this.onBackClick) this.link.removeEventListener('click', this.onBackClick);
    }
  });
}


